function initializeNavbar() {
  const header = document.querySelector(".site-header");
  const menuWrapper = document.querySelector(".navbar__menu-wrapper");
  const menuTrigger = document.querySelector(".navbar__menu-trigger");
  const subMenuTriggers = document.querySelectorAll(
    ".menu-item-has-children > a"
  );
  const closeButton = document.querySelector(".navbar__menu-close-button");

  const searchMenuWrapper = document.querySelector(".navbar__search");
  const searchTrigger = document.querySelector(".navbar__search-trigger");
  const searchCloseButton = document.querySelector(
    ".navbar__search-close-button"
  );
  const searchForm = document.querySelector(".navbar__search-form");

  if (!menuWrapper) {
    return;
  }

  menuTrigger.addEventListener("click", () => {
    openNavMenu(menuWrapper);
  });

  searchTrigger.addEventListener("click", () => {
    openNavMenu(searchMenuWrapper);
    const input = searchMenuWrapper.querySelector(".navbar__search-input");

    if (input) {
      input.focus();
    }
  });

  closeButton.addEventListener("click", () => {
    closeNavMenu(menuWrapper);
  });

  searchCloseButton.addEventListener("click", () => {
    closeNavMenu(searchMenuWrapper);
  });

  menuWrapper.addEventListener("click", (e) => {
    if (e.target.closest(".navbar__menu-container")) {
      return;
    }

    closeNavMenu(menuWrapper);
  });

  searchMenuWrapper.addEventListener("click", (e) => {
    if (e.target.closest(".navbar__search-container")) {
      return;
    }

    closeNavMenu(searchMenuWrapper);
  });

  subMenuTriggers.forEach((subMenuTrigger) => {
    subMenuTrigger.addEventListener("click", (e) => {
      // Second-level handling start. Under a .sub-menu
      if (e.currentTarget.closest(".sub-menu")) {
        // This should be a click-through link on mobile
        if (e.currentTarget.closest(".menu-main-menu-container--mobile")) {
          return;
        }
      }
      // Second-level handling end

      e.preventDefault();

      const menuItem = e.currentTarget.closest(".menu-item-has-children");
      const otherMenuItemsHaveChildren =
        menuItem.parentElement.querySelectorAll(
          ".menu-item-has-children.active"
        );
      const isActive = menuItem.classList.contains("active");

      otherMenuItemsHaveChildren.forEach((other) => {
        closeSubMenu(other);
      });

      if (!isActive) {
        openSubMenu(menuItem);
      }
    });
  });

  let isAnchorScroll = false;
  let scrollTimeout;

  document.querySelectorAll('a[data-link]').forEach(anchor => {
    anchor.addEventListener('click', function() {
      isAnchorScroll = true;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isAnchorScroll = false;
      }, 800);
    });
  });

  const bodyOffset = document.body.getBoundingClientRect();
  if (bodyOffset.top < 0 && !isAnchorScroll) {
    header.classList.add("scrolled-up");
  }
  let lastScrollTop = 0;
  document.addEventListener("scroll", () => {
    const bodyOffset = document.body.getBoundingClientRect();
    const scrollDirection = lastScrollTop > -bodyOffset.top ? "up" : "down";
    const headerHeight = header.offsetHeight;
    const scrollY = -bodyOffset.top;

    lastScrollTop = -bodyOffset.top;

    if (scrollDirection === "up" && !isAnchorScroll) {
      header.classList.remove("scrolled-down");
      header.classList.add("scrolled-up");
      document.documentElement.style.setProperty('--header-visible-height', headerHeight + "px");

      if (scrollY <= 1) {
        header.classList.remove("scrolled-down");
        header.classList.remove("scrolled-up");
        document.documentElement.style.setProperty('--header-visible-height', headerHeight + "px");
      }
    } else {
      if (scrollY > headerHeight) {
        header.classList.remove("scrolled-up");
        header.classList.add("scrolled-down");
        document.documentElement.style.setProperty('--header-visible-height', "0px");
      }
    } 
  });

  searchForm.addEventListener("submit", (e) => {
    e.preventDefault();
    doSearch(e.currentTarget, 1);
  });

  const searchInput = searchForm.querySelector(".navbar__search-input");
  searchInput.addEventListener(
    "input",
    debounce((e) => {
      doSearch(searchInput.closest(".navbar__search-form"), 1);
    }, 700)
  );
}

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function openSubMenu(menuItem) {
  menuItem.classList.add("active");
  menuItem.querySelector(".sub-menu").classList.add("active");

  const subMenu = menuItem.closest(".sub-menu");
  if (subMenu) {
    subMenu.classList.add("has-sub-menu-open");
  }
}

function closeSubMenu(menuItem) {
  menuItem.classList.remove("active");
  menuItem.querySelector(".sub-menu").classList.remove("active");
  menuItem.querySelector(".sub-menu").classList.remove("has-sub-menu-open");

  let transitionEndHandler = null;
  const subMenu = menuItem.closest(".sub-menu");

  if (subMenu) {
    transitionEndHandler = () => {
      subMenu.classList.remove("has-sub-menu-open");
      subMenu.removeEventListener("transitionend", transitionEndHandler);
    };

    subMenu.addEventListener("transitionend", transitionEndHandler);
  }
}

function openNavMenu(menuWrapper) {
  menuWrapper.classList.add("active");
  document.body.classList.add("overflow-hidden");
}

function closeNavMenu(menuWrapper) {
  menuWrapper.classList.remove("active");
  document.body.classList.remove("overflow-hidden");

  const menuItemsHaveChildren = menuWrapper.querySelectorAll(
    ".menu-item-has-children.active"
  );

  menuItemsHaveChildren.forEach((menuItem) => {
    closeSubMenu(menuItem);
  });
}

function doSearch(form, page) {
  const params = new URLSearchParams(new FormData(form));
  const url = new URL(fg_theme.ajax_url);
  const searchResultWrapper = form.parentElement.querySelector(
    ".search__result-wrapper"
  );

  url.searchParams.append("action", "fg_search_api");
  url.searchParams.append("paged", page);

  Array.from(params.entries()).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  searchResultWrapper.classList.add("search__result-wrapper--loading");

  fetch(url)
    .then((resp) => {
      return resp.json();
    })
    .then(({ html }) => {
      searchResultWrapper.innerHTML = html;
      addSearchResultEvents(searchResultWrapper, form);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      searchResultWrapper.classList.remove("search__result-wrapper--loading");
    });
}

function addSearchResultEvents(wrapper, form) {
  const prev = wrapper.querySelector(".search__prev");
  const next = wrapper.querySelector(".search__next");
  const pageNavigate = (e) => {
    doSearch(form, e.currentTarget.dataset.page);
  };

  prev.addEventListener("click", pageNavigate);
  next.addEventListener("click", pageNavigate);
}

if (document.readyState !== "loading") {
  initializeNavbar();
} else {
  document.addEventListener("DOMContentLoaded", initializeNavbar);
}
